import {LobbyImage, StoreExpansionType, GameTimerOption} from '@colonist/types'
import {ExtensionSettingEnum, MapSettingEnum, ModeSettingEnum, TemporaryModeSettingEnum, CurrentStateControllerTypeEnum} from '@colonist/game-base-types'
import {GameModeTranslationKeyContext, TranslationObject} from '@colonist/i18n'
import {ProductionController} from '@colonist/shared-types'
import {CardEnum, CardTypeEnum, TileCornerBuildingType} from '@colonist/game-states'

export abstract class BaseGameModeData {
    abstract readonly premiumExpansionAccess: StoreExpansionType[] // set to [] for free
    abstract readonly modeSetting: ModeSettingEnum
    abstract readonly extensionSetting: ExtensionSettingEnum
    abstract readonly startingSettlementPlacements: TileCornerBuildingType[]
    abstract readonly activeResourceCardTypes: CardTypeEnum[]
    abstract readonly activeDevelopmentCardTypes: CardTypeEnum[]
    abstract readonly startingDevelopmentCards: CardEnum[]
    abstract readonly productionController: ProductionController
    abstract readonly name: TranslationObject
    abstract readonly active: boolean
    abstract readonly defaultMap: MapSettingEnum
    abstract readonly defaultPlayerCount: number
    abstract readonly defaultVPsToWin: number
    abstract readonly additionalVPsForGameModeCombinations: number
    abstract readonly icon: LobbyImage
    abstract readonly translationKeyContext: GameModeTranslationKeyContext
    readonly defaultCardDiscardLimit: number = 7
    protected readonly minimumPlayerCount: number = 2
    abstract readonly currentStateControllerType: CurrentStateControllerTypeEnum

    abstract readonly allowedGameTimers: GameTimerOption[]

    abstract temporaryModeSetting: TemporaryModeSettingEnum // Dec 6, 2020. This is a placeholder until the room design is complete

    isGameModePremium(): boolean {
        if(this.premiumExpansionAccess.length == 0) return false
        return true
    }

    getAllowablePlayerCount(): number[] {
        switch(this.extensionSetting) {
            case ExtensionSettingEnum.Players4: return [1, 2, 3, 4]
            case ExtensionSettingEnum.Players56: return [5, 6]
            case ExtensionSettingEnum.Players78: return [7, 8]
        }
    }

    getNewInstanceOfData(): BaseGameModeData {
        /* eslint-disable @typescript-eslint/prefer-function-type */
        const newInstance = new (this.constructor as {new (): BaseGameModeData})()
        return newInstance
    }
}
